const domainName = '/otssign'
export default domainName
